import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { QuestionTypeName } from '../../../classes/learnware/LearnwareEnums';
import { Actor_ } from '../../../components/actor/Actor_';
import { Aspect_ } from '../../../components/actor/Aspect_';
export class SkeletonsAssociate extends SkeletonRegistryCategory {
    label = 'Associate';
    constructor(parent) {
        super(parent);
        super.init();
    }
    draftAssociateCurrentAssociation = () => new SkeletonRegistryItem({
        label: 'Current Association',
        jsx: ({ questionAssociate }) => {
            if (questionAssociate.questionType !== QuestionTypeName.Associate)
                return null;
            if (!questionAssociate.currentAssociation)
                return null;
            return React.createElement(Actor_, { actor: questionAssociate.currentAssociation, key: questionAssociate.currentAssociation.tid });
        },
    });
    draftAssociateAllAssociation = () => new SkeletonRegistryItem({
        label: 'All Associations',
        jsx: ({ questionAssociate }) => {
            if (questionAssociate.questionType !== QuestionTypeName.Associate)
                return null;
            return (React.createElement(Aspect_, { aspect: questionAssociate.ownAspect.associations }, questionAssociate.allAssociations.map(accociate => (React.createElement(Actor_, { actor: accociate, key: `${accociate.tid}_${questionAssociate.tid}` })))));
        },
    });
    associateAllNakedAssociations = () => new SkeletonRegistryItem({
        label: 'All Associations Naked',
        jsx: ({ questionAssociate }) => {
            if (questionAssociate.questionType !== QuestionTypeName.Associate)
                return null;
            return questionAssociate.allAssociations.map(accociate => React.createElement(Actor_, { actor: accociate, key: accociate.tid }));
        },
    });
}
